import gql from 'graphql-tag';

import formTemplateFragment from '~/shared/graphql-queries/form-templates/form-template-fragment';

export default gql`
  query findManyFormTemplateQuery(
    $limit: Int = 20
    $filter: FilterFindManyFormTemplateInput
  ) {
    findManyFormTemplateQuery(
      filter: $filter
      skip: 0
      limit: $limit
      sort: _ID_ASC
    ) {
      ...FormTemplateFragment
    }
  }
  ${formTemplateFragment}
`;
